import { render, staticRenderFns } from "./bulkApproveReject.vue?vue&type=template&id=3cb247c9&"
import script from "./bulkApproveReject.vue?vue&type=script&lang=js&"
export * from "./bulkApproveReject.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports